import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'hourglass-cog',
  size: 24,
  node: [
    ['path', { d: 'm14.305 19.53.923-.382', key: '3m78fa' }],
    ['path', { d: 'm15.228 16.852-.923-.383', key: 'npixar' }],
    ['path', { d: 'm16.852 15.228-.383-.923', key: '5xggr7' }],
    ['path', { d: 'm16.852 20.772-.383.924', key: 'dpfhf9' }],
    [
      'path',
      { d: 'M17 2v4.172a2 2 0 0 1-.586 1.414l-8.828 8.828A2 2 0 0 0 7 17.828V22', key: '1ps5j6' },
    ],
    ['path', { d: 'm19.148 15.228.383-.923', key: '1reyyz' }],
    ['path', { d: 'm19.53 21.696-.382-.924', key: '1goivc' }],
    ['path', { d: 'm20.772 16.852.924-.383', key: 'htqkph' }],
    ['path', { d: 'm20.772 19.148.924.383', key: '9w9pjp' }],
    ['path', { d: 'M5 22h6.159', key: '56uwxb' }],
    ['path', { d: 'M5 2h14', key: 'pdyrp9' }],
    ['path', { d: 'M7 2v4.172a2 2 0 0 0 .586 1.414l5.188 5.188', key: 'ydx7yk' }],
    ['circle', { cx: '18', cy: '18', r: '3', key: '1xkwt0' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name HourglassCog
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTQuMzA1IDE5LjUzLjkyMy0uMzgyIiAvPgogIDxwYXRoIGQ9Im0xNS4yMjggMTYuODUyLS45MjMtLjM4MyIgLz4KICA8cGF0aCBkPSJtMTYuODUyIDE1LjIyOC0uMzgzLS45MjMiIC8+CiAgPHBhdGggZD0ibTE2Ljg1MiAyMC43NzItLjM4My45MjQiIC8+CiAgPHBhdGggZD0iTTE3IDJ2NC4xNzJhMiAyIDAgMCAxLS41ODYgMS40MTRsLTguODI4IDguODI4QTIgMiAwIDAgMCA3IDE3LjgyOFYyMiIgLz4KICA8cGF0aCBkPSJtMTkuMTQ4IDE1LjIyOC4zODMtLjkyMyIgLz4KICA8cGF0aCBkPSJtMTkuNTMgMjEuNjk2LS4zODItLjkyNCIgLz4KICA8cGF0aCBkPSJtMjAuNzcyIDE2Ljg1Mi45MjQtLjM4MyIgLz4KICA8cGF0aCBkPSJtMjAuNzcyIDE5LjE0OC45MjQuMzgzIiAvPgogIDxwYXRoIGQ9Ik01IDIyaDYuMTU5IiAvPgogIDxwYXRoIGQ9Ik01IDJoMTQiIC8+CiAgPHBhdGggZD0iTTcgMnY0LjE3MmEyIDIgMCAwIDAgLjU4NiAxLjQxNGw1LjE4OCA1LjE4OCIgLz4KICA8Y2lyY2xlIGN4PSIxOCIgY3k9IjE4IiByPSIzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/hourglass-cog
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HourglassCog = createLucideIcon(__iconData);

export default HourglassCog;
